<div class="patient-registration">
    <div class="row mr-b--md">
        <div class="col-xs-4">
            <div class="klenico-logo"></div>
        </div>
        <div class="col-xs-8 col-md-4 offset-md-4">
            <ul class="list-inline patient-registration__languages">
                <li class="list-inline-item patient-registration__languages__item"
                    *ngFor="let language of languages">
                    <button class="btn btn-link patient-registration__languages__link{{ isActive(language['locale']) }}"
                            (click)="setLanguage(language['locale'])">
                        {{ language['name'] | translate }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!registerSuccess">
        <ng-container *ngIf="templateName === templates.default || !templates[templateName]">
            <div class="patient-registration__header">
                <div class="row">
                    <div class="col-xs-12 col-lg-6 col-md-8">
                        {{ 'Please create an account so we can send you your diagnosis afterwards' | translate }}
                    </div>
                </div>
            </div>
            <form [formGroup]="form" class="mat-form" novalidate>
                <div class="patient-registration__body">
                    <div class="row" *ngIf="errorMessage">
                        <div class="col-xs-12">
                            <span class="text-danger">{{ errorMessage | translate : errorData }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-6 patient-registration__body--header">
                            {{ 'Your personal data' | translate }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input id="name-text" type="text" autocomplete="off" matInput [placeholder]="'Given Name' | translate" required="required" formControlName="name" />
                                <small class="form-text text-danger" [hidden]="form.controls.name.valid || (form.controls.name.pristine && !formSubmitted)">
                                    {{ 'Given name is required' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input id="last-name-text" type="text" autocomplete="off" matInput [placeholder]="'Last Name' | translate" required="required" formControlName="surname" />
                                <small class="form-text text-danger" [hidden]="form.controls.surname.valid || (form.controls.surname.pristine && !formSubmitted)">
                                    {{ 'Surname is required' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input id="email-text" type="email" autocomplete="off" matInput [placeholder]="'Email Address' | translate" required="required" formControlName="email" />
                                <small class="form-text text-danger" [hidden]="form.controls.email.valid || (form.controls.email.pristine && !formSubmitted)">
                                    {{ 'E-Mail address is required' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input id="confirm-email-text" type="email" autocomplete="off" matInput [placeholder]="'Confirm E-Mail address' | translate" required="required" formControlName="confirm_email" />
                                <small class="form-text text-danger" [hidden]="form.controls.confirm_email.valid || (form.controls.confirm_email.pristine && !formSubmitted)">
                                    <ng-container *ngIf="form.controls.confirm_email.hasError('required')">
                                        {{ 'Confirm E-Mail address is required' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="form.controls.confirm_email.hasError('mismatch')">
                                        {{ 'E-Mail does not match' | translate }}
                                    </ng-container>
                                </small>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input type="text" autocomplete="off" [ngClass]="showhideBtn['password'] ? '' : 'jtext'" matInput [placeholder]="'Password' | translate" required="required" formControlName="password"/>
                                <span class="password-btn" matSuffix (click)="showhideBtn['password'] = !showhideBtn['password']">
                                    {{  showhideBtn['password'] ? ('Hide' | translate) : ('Show' | translate) }}
                                </span>
                                <div class="form-text password">
                                    <small [ngClass]="(!form.controls.password.value || form.controls.password.hasError('minlength')) ? 'text-danger' : 'text-success'">
                                        {{ 'At least 8 characters long' | translate }}
                                    </small>
                                    <small [ngClass]="(!form.controls.password.value || form.controls.password.hasError('haveNumber')) ? 'text-danger' : 'text-success'">
                                        {{ 'At least 1 number' | translate }}
                                    </small>
                                    <small [ngClass]="(!form.controls.password.value || form.controls.password.hasError('haveSpecialCharacter')) ? 'text-danger' : 'text-success'">
                                        {{ 'At least 1 special character' | translate }}
                                    </small>
                                </div>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-xs-12 col-lg-4 col-md-5">
                            <mat-form-field class="ps-content">
                                <input type="text" autocomplete="off" [ngClass]="showhideBtn['confirm_password'] ? '' : 'jtext'" matInput [placeholder]="'Confirm Password' | translate" required="required" formControlName="confirm_password" />
                                <span class="password-btn" matSuffix (click)="showhideBtn['confirm_password'] = !showhideBtn['confirm_password']">
                                    {{  showhideBtn['confirm_password'] ? ('Hide' | translate) : ('Show' | translate) }}
                                </span>
                                <small class="form-text text-danger" [hidden]="form.controls.confirm_password.valid || (form.controls.confirm_password.pristine && !formSubmitted)">
                                    <ng-container *ngIf="form.controls.confirm_password.hasError('required')">
                                        {{ 'Confirm password is required.' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="form.controls.confirm_password.hasError('mismatch')">
                                        {{ 'Password does not match' | translate }}
                                    </ng-container>
                                </small>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 required-text">
                            *{{ 'Mandatory fields' | translate }}
                        </div>
                    </div>
                </div>
                <div class="patient-registration__footer">
                    <div class="row">
                        <div class="col-xs-12 col-md-8 offset-md-4">
                            <div class="row">
                                <div class="col-xs-12 col-md-8 col-lg-8 offset-md-1">
                                    <div class="form-group">
                                        <mat-slide-toggle formControlName="checked">
                                            <ng-container>
                                                {{ 'I agree that my details will be saved for my therapist and for therapy purposes.' | translate }}
                                            </ng-container>
                                        </mat-slide-toggle>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-4 col-lg-3">
                                    <div class="text-xs-right">
                                        <button type="button" class="btn btn-primary btn-register" [disabled]="!form.controls.checked.value" (click)="submit(form.value, form.valid)">
                                            {{ 'Register' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>            
        </ng-container>
        <ng-container *ngIf="templates[templateName]">
            <app-custom-patient-registration
                [errorMessage]="errorMessage"
                [errorData]="errorData"
                [clinicId]="clinicId"
                [languages]="languages"
                [languageId]="languageId" 
                [form]="form" 
                [formSubmitted]="formSubmitted"
                [headerText]="templates[templateName].header"
                [clinicName]="templates[templateName].name"
                [displayForms]="templates[templateName].forms"
                (submitForm)="submit($event.value, $event.valid)">
            </app-custom-patient-registration>
        </ng-container>
    </div>

    <div class="register-success" *ngIf="registerSuccess">
        <div class="register-success__content">
            <div class="register-success__content--header"></div>
            <ng-container *ngIf="templateName === templates.default">
                <div class="register-success__content--body">{{ 'Please confirm your e-mail' | translate}}</div>
                <div class="register-success__content--footer">{{ 'You will receive an email from us in a moment.' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="templateName">
                <div class="register-success__content--body">{{ 'Sanitas - Please confirm your e-mail' | translate}}</div>
                <div class="register-success__content--footer">{{ 'Sanitas - You will receive an email from us in a moment.' | translate}}</div>
            </ng-container>
        </div>
    </div>
</div>